// extracted by mini-css-extract-plugin
export default {"guideVideo":"GuideVideoView_guideVideo__hAFIc","videobox":"GuideVideoView_videobox__lfan4","iconClose":"GuideVideoView_iconClose__pjE+V"};